module.exports = {"id":"232517","name":"Nicolás Silva","rating":"71","photo":"./data/images/photos/3/232517.png","club":{"name":"Parque Patricios","logo":"./data/images/clubs/ParquePatricios.png"},"positions":["MD","MOC","MG","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NicolasSilva0.json
// module id = 3212
// module chunks = 0